import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import Api from "@/api/task";
import { ElMessage } from "element-plus";
export default {
  __name: 'assignTask',
  props: {
    userList: {
      type: Array,
      default: () => []
    }
  },
  emits: ["loadList"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      t
    } = useI18n();
    const props = __props;
    const emits = __emit;
    const params = ref({
      ids: "",
      assignId: ""
    });
    const dialogFormVisible = ref(false);
    const open = val => {
      dialogFormVisible.value = true;
      params.value.ids = val || [];
    };
    const handleClick = async () => {
      const {
        data
      } = await Api.assignTasks(params.value);
      if (data.code === 0) {
        ElMessage.success(t("action.success"));
        emits("loadList");
        dialogFormVisible.value = false;
      }
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "status-dia",
        title: _ctx.$t('task.list.assignTasks'),
        modelValue: dialogFormVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogFormVisible.value = $event)
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => dialogFormVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleClick
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.confirmBtn")), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: params.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('task.list.assignUser')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: params.value.assignId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.assignId = $event),
              style: {
                "width": "200px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.userList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  value: item.id,
                  label: item.name
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
};